import Vue from "vue";
import VTooltip from "v-tooltip";

const options = {
  defaultOffset: 3,
};

Vue.use(VTooltip, options);
